import { AlternativeData } from "@/types/alternative";

    
export const toatal_sqm = (alternative: AlternativeData) => {
        return alternative.residential_area.graph_data["סיום פרויקט"] + alternative.commercial_area.graph_data["סיום פרויקט"] + alternative.industrial_area.graph_data["סיום פרויקט"] + alternative.public_building_area.graph_data["סיום פרויקט"] ;
}